// `as const` so each value is its own string-literal type — required for
// IAnyPolicyScan's discriminated narrowing on IAutosureMbiPolicyScan
// (policyType: 'MBI'). Literal types remain assignable to string, so
// existing consumers are unaffected.
export const INSURANCE_TYPES_NAMES = {
  VEHICLE: 'Vehicle',
  MOTORCYCLE: 'Motorcycle',
  HOME: 'House',
  CONTENT: 'Contents',
  HOME_CONTENTS: 'House & Contents',
  RENTERS: 'Renters',
  LANDLORD: 'Landlord',
  HEALTH: 'Health',
  LIFE: 'Life',
  LIFE_REFERRAL: 'Life-referral',
  DISABILITY: 'TPD',
  PET: 'Pet',
  MORTGAGE: 'Mortgage Repayment',
  REDUNDANCY: 'Redundancy',
  TRAUMA: 'Trauma',
  INCOME: 'Income Protection',
  CREDIT_CARD: 'Credit Card Benefits',
  TRAVEL: 'Travel',
  BOAT: 'Boat',
  MOBILE: 'Mobile',
  CANCER: 'Cancer',
  ACCIDENTAL_INJURY: 'Accidental Injury',
  RENT_PROTECTION: 'Rent Protection',
  BICYCLE: 'Bicycle',
  MBI: 'MBI',
  RV: 'RV/Caravan',
  OTHER: 'Other',
} as const;